import _ from "lodash";

export const checkIfCaptchaEnabled = (currentWebsite: any) => {
  const is_enabled = _.get(currentWebsite, "recaptcha.is_enabled", false);
  const sitekey = _.get(currentWebsite, "recaptcha.sitekey", "");

  return is_enabled && !!sitekey;
};
